import * as io from 'socket.io-client';
import { Store } from 'redux';
import { AppState } from '../reducers';
import i18next from 'i18next';

let socketService: SocketService | null = null;

export class SocketService {
    private _socket: any = null;
    private _connected: boolean = false;
    private _disconnectHandler: Function;
    // @ts-ignore
    private _store: Store<AppState> = null;

    static getInstance(): SocketService {
        if (!socketService) {
            socketService = new SocketService();
            /* tslint:disable:no-string-literal */
            (window as any)['socketService'] = socketService;
        }
        return socketService;
    }

    get connected(): boolean {
        return this._connected;
    }

    get socket(): any {
        return this._socket;
    }

    set store(value: Store<AppState>) {
        this._store = value;
    }

    set onDisconnect(value: Function) {
        this._disconnectHandler = value;
    }

    public connect(accessToken: string): Promise<SocketService> {
        if (this._socket) {
            this._socket.close();
        }
        return new Promise((resolve: any) => {
            return fetch('/frontend/config/chat')
                .then(response => response.text())
                .then(SOCKET_HOST => {
                    const REACT_APP_SOCKET_HOST: any = process.env.REACT_APP_SOCKET_HOST;
                    this._socket = io.connect(`${REACT_APP_SOCKET_HOST}/`, {transports: ['websocket'], query: `user_type=client&user_token=${accessToken}&client_version=6`});
                    this._socket.on('connect', () => {
                        this._connected = true;
                        resolve(this);
                    });
                    this._socket.on('event', (event: any) => {
                        console.log();
                    });
                    this._socket.on('disconnect', () => {
                        if (this.socket.receiveBuffer[0] && this.socket.receiveBuffer[0][0] === 'disconnect_reason') {
                            console.log(this.socket.receiveBuffer[0][1].reason);
                            alert(i18next.t('error_contact_konsierge'));
                        }
                        if (this._disconnectHandler) {
                            this._disconnectHandler();
                        }
                        this._connected = false;
                    });
                });
        });
    }

    public emit(event: string, ...data: any[]): Promise<any> {
        return new Promise((resolve: Function) => {
            if (data) {
                this._socket.emit(event, ...data.filter((i: any) => !!i), (result: any) => {
                    resolve(result);
                });
            } else {
                this._socket.emit(event, (result: any) => {
                    resolve(result);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/lib/socket.ts